// extracted by mini-css-extract-plugin
export default {"dialogClassName":"super-speed-box-confirmation-popup__dialogClassName___IufP4"};